const stockSampleInputs: string[] = [
    '5-3/4 x 8-3/16',
    '5 x 7-1/2',
    '7 x 10',
    '5-11/16 x 8',
    '5-3/4 x 8-1/4',
    '5-1/2 x 7-1/2',
    '5 x 7',
    '6 x 8',
    '5-1/2 x 8-1/4',
    '7-1/8 x 10-1/8',
    '7-1/8 x 6-1/2',
    '5-1/5 x 7-1/5',
    '5-1/2 x 7-3//4',
];

function ParseTrimText(str: string) {
    if(str == null||str.length <1) {
        return str;
    }
    const splitStr = str.split(' ');
    switch (splitStr.length) {
        case 3:
            const first = splitStr[0];
            //const x = splitStr[1];
            const second = splitStr[2];
            return `${customRound(ParseExpandedFraction(first))} x ${customRound(ParseExpandedFraction(second))} in.`;
        default:
            throw new FractionParseError('Could not Parse String');
    }
}

function ParseExpandedFraction(str: string) {
    const splitStr = str.split('-');
    switch (splitStr.length) {
        case 1:
            return parseInt(splitStr[0]);
        case 2:
            const fracSplitStr = splitStr[1].split('/');
            if (fracSplitStr.length != 2) {
                throw new FractionParseError('Could not Parse FractionString');
            }
            const first = parseInt(fracSplitStr[0]);
            const second = parseInt(fracSplitStr[1]);
            return parseInt(splitStr[0]) + (first / second);
        default:
            throw new FractionParseError('Could not Parse FractionString');
    }

}

class FractionParseError extends Error {
    constructor(msg: string) {
        super(msg);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, FractionParseError.prototype);
    }
}

export function TryParseTrimText(str: string) {
    let result = str;
    try {
        result = ParseTrimText(str);
        return { success: true, result: result } as const;

    } catch (error) {
        if (error instanceof FractionParseError) {
            return { success: false, result: result } as const;
        }
        throw error;
    }
}

function customRound(number) {
    if (Number.isInteger(number) || number % 1 === 0) {
        // If the number is an integer or has no decimal places, return it as is
        return number;
    } else {
        // If the number has more than two decimal places, round it to two decimal places
        return +number.toFixed(2);
    }
}